function PaginationArrow(props) {
  const isPreviousArrow = props.type === 'previous';

  return (
    <div
      onClick={() => {
        if (!props.disabled) {
          props.onClick();
        }
      }}
      role={!props.disabled ? 'button' : null}
      className={`d-flex align-items-center user-select-none ${
        isPreviousArrow ? '' : 'flex-row-reverse'
      } ${props.disabled ? 'text-secondary-black' : ''}`}
    >
      <span className='material-symbols-outlined'>
        chevron_{isPreviousArrow ? 'left' : 'right'}
      </span>
      <span className='d-none d-md-block'>
        {isPreviousArrow ? 'Föregående' : 'Nästa'}
      </span>
    </div>
  );
}

export default PaginationArrow;
